import { ContentStateInterface } from '../../../../../../@types/types'
import { RealEstateOtherCost } from '../../../../../../@types/real-estate-api-types'
import { cutOfLeadingZeros } from '../../../../../../services/conversion/conversionServices'
import { DE, parseDecimal } from '../../../../../../i18next/decimal'

export const otherCostsToApi = (insertionData: ContentStateInterface): RealEstateOtherCost => ({
  additionalCosts: insertionData.additionalCosts,
  deposit: cutOfLeadingZeros(insertionData.deposit),
  heatingCosts: parseDecimal(insertionData.heatingCosts, DE),
  heatingCostsOption: insertionData.heatingCostsOption ? 'heatingCostsIncluded' : 'heatingCostsNotIncluded',
})
